(function(root, factory) {
  if (typeof module === "object" && module.exports) {
    module.exports = factory();
  } else if (typeof exports === "object") {
    exports["StyleTokens"] = factory();
  } else if (typeof define === "function" && define.amd) {
    define([], factory);
  } else {
    root["StyleTokens"] = factory();
  }
}(this, function() {
  return {
  "component": {
    "container": {
      "xs": {
        "width": {
          "value": "auto",
          "original": {
            "value": "auto"
          },
          "name": "ComponentContainerXsWidth",
          "attributes": {
            "category": "component",
            "type": "container",
            "item": "xs",
            "subitem": "width"
          },
          "path": [
            "component",
            "container",
            "xs",
            "width"
          ]
        }
      },
      "sm": {
        "width": {
          "value": "750px",
          "original": {
            "value": "750px"
          },
          "name": "ComponentContainerSmWidth",
          "attributes": {
            "category": "component",
            "type": "container",
            "item": "sm",
            "subitem": "width"
          },
          "path": [
            "component",
            "container",
            "sm",
            "width"
          ]
        }
      },
      "md": {
        "width": {
          "value": "970px",
          "original": {
            "value": "970px"
          },
          "name": "ComponentContainerMdWidth",
          "attributes": {
            "category": "component",
            "type": "container",
            "item": "md",
            "subitem": "width"
          },
          "path": [
            "component",
            "container",
            "md",
            "width"
          ]
        }
      },
      "lg": {
        "width": {
          "value": "1170px",
          "original": {
            "value": "1170px"
          },
          "name": "ComponentContainerLgWidth",
          "attributes": {
            "category": "component",
            "type": "container",
            "item": "lg",
            "subitem": "width"
          },
          "path": [
            "component",
            "container",
            "lg",
            "width"
          ]
        }
      }
    }
  },
  "breakpoint": {
    "xs": {
      "min": {
        "value": "0px",
        "type": "breakpoint",
        "original": {
          "value": "0px",
          "type": "breakpoint"
        },
        "name": "BreakpointXsMin",
        "attributes": {
          "category": "breakpoint",
          "type": "xs",
          "item": "min"
        },
        "path": [
          "breakpoint",
          "xs",
          "min"
        ]
      },
      "max": {
        "value": "575.98px",
        "type": "breakpoint",
        "original": {
          "value": "575.98px",
          "type": "breakpoint"
        },
        "name": "BreakpointXsMax",
        "attributes": {
          "category": "breakpoint",
          "type": "xs",
          "item": "max"
        },
        "path": [
          "breakpoint",
          "xs",
          "max"
        ]
      }
    },
    "sm": {
      "min": {
        "value": "576px",
        "type": "breakpoint",
        "original": {
          "value": "576px",
          "type": "breakpoint"
        },
        "name": "BreakpointSmMin",
        "attributes": {
          "category": "breakpoint",
          "type": "sm",
          "item": "min"
        },
        "path": [
          "breakpoint",
          "sm",
          "min"
        ]
      },
      "max": {
        "value": "767px",
        "type": "breakpoint",
        "original": {
          "value": "767px",
          "type": "breakpoint"
        },
        "name": "BreakpointSmMax",
        "attributes": {
          "category": "breakpoint",
          "type": "sm",
          "item": "max"
        },
        "path": [
          "breakpoint",
          "sm",
          "max"
        ]
      }
    },
    "md": {
      "min": {
        "value": "768px",
        "type": "breakpoint",
        "original": {
          "value": "768px",
          "type": "breakpoint"
        },
        "name": "BreakpointMdMin",
        "attributes": {
          "category": "breakpoint",
          "type": "md",
          "item": "min"
        },
        "path": [
          "breakpoint",
          "md",
          "min"
        ]
      },
      "max": {
        "value": "991.98px",
        "type": "breakpoint",
        "original": {
          "value": "991.98px",
          "type": "breakpoint"
        },
        "name": "BreakpointMdMax",
        "attributes": {
          "category": "breakpoint",
          "type": "md",
          "item": "max"
        },
        "path": [
          "breakpoint",
          "md",
          "max"
        ]
      }
    },
    "lg": {
      "min": {
        "value": "992px",
        "type": "breakpoint",
        "original": {
          "value": "992px",
          "type": "breakpoint"
        },
        "name": "BreakpointLgMin",
        "attributes": {
          "category": "breakpoint",
          "type": "lg",
          "item": "min"
        },
        "path": [
          "breakpoint",
          "lg",
          "min"
        ]
      },
      "max": {
        "value": "1199.98px",
        "type": "breakpoint",
        "original": {
          "value": "1199.98px",
          "type": "breakpoint"
        },
        "name": "BreakpointLgMax",
        "attributes": {
          "category": "breakpoint",
          "type": "lg",
          "item": "max"
        },
        "path": [
          "breakpoint",
          "lg",
          "max"
        ]
      }
    },
    "xl": {
      "min": {
        "value": "1200px",
        "type": "breakpoint",
        "original": {
          "value": "1200px",
          "type": "breakpoint"
        },
        "name": "BreakpointXlMin",
        "attributes": {
          "category": "breakpoint",
          "type": "xl",
          "item": "min"
        },
        "path": [
          "breakpoint",
          "xl",
          "min"
        ]
      }
    }
  },
  "color": {
    "general": {
      "black": {
        "100": {
          "value": "#000000",
          "type": "color",
          "original": {
            "value": "#000000",
            "type": "color"
          },
          "name": "ColorGeneralBlack100",
          "attributes": {
            "category": "color",
            "type": "general",
            "item": "black",
            "subitem": "100"
          },
          "path": [
            "color",
            "general",
            "black",
            "100"
          ]
        }
      },
      "white": {
        "100": {
          "value": "#ffffff",
          "type": "color",
          "original": {
            "value": "#FFFFFF",
            "type": "color"
          },
          "name": "ColorGeneralWhite100",
          "attributes": {
            "category": "color",
            "type": "general",
            "item": "white",
            "subitem": "100"
          },
          "path": [
            "color",
            "general",
            "white",
            "100"
          ]
        }
      },
      "blue": {
        "5": {
          "value": "#f2f7ff",
          "type": "color",
          "original": {
            "value": "#F2F7FF",
            "type": "color"
          },
          "name": "ColorGeneralBlue5",
          "attributes": {
            "category": "color",
            "type": "general",
            "item": "blue",
            "subitem": "5"
          },
          "path": [
            "color",
            "general",
            "blue",
            "5"
          ]
        },
        "10": {
          "value": "#e6f0ff",
          "type": "color",
          "original": {
            "value": "#E6F0FF",
            "type": "color"
          },
          "name": "ColorGeneralBlue10",
          "attributes": {
            "category": "color",
            "type": "general",
            "item": "blue",
            "subitem": "10"
          },
          "path": [
            "color",
            "general",
            "blue",
            "10"
          ]
        },
        "20": {
          "value": "#cce0ff",
          "type": "color",
          "original": {
            "value": "#CCE0FF",
            "type": "color"
          },
          "name": "ColorGeneralBlue20",
          "attributes": {
            "category": "color",
            "type": "general",
            "item": "blue",
            "subitem": "20"
          },
          "path": [
            "color",
            "general",
            "blue",
            "20"
          ]
        },
        "50": {
          "value": "#80b3ff",
          "type": "color",
          "original": {
            "value": "#80B3FF",
            "type": "color"
          },
          "name": "ColorGeneralBlue50",
          "attributes": {
            "category": "color",
            "type": "general",
            "item": "blue",
            "subitem": "50"
          },
          "path": [
            "color",
            "general",
            "blue",
            "50"
          ]
        },
        "75": {
          "value": "#408cff",
          "type": "color",
          "original": {
            "value": "#408CFF",
            "type": "color"
          },
          "name": "ColorGeneralBlue75",
          "attributes": {
            "category": "color",
            "type": "general",
            "item": "blue",
            "subitem": "75"
          },
          "path": [
            "color",
            "general",
            "blue",
            "75"
          ]
        },
        "100": {
          "value": "#0066ff",
          "type": "color",
          "original": {
            "value": "#0066FF",
            "type": "color"
          },
          "name": "ColorGeneralBlue100",
          "attributes": {
            "category": "color",
            "type": "general",
            "item": "blue",
            "subitem": "100"
          },
          "path": [
            "color",
            "general",
            "blue",
            "100"
          ]
        }
      },
      "green": {
        "5": {
          "value": "#f2fbf2",
          "type": "color",
          "original": {
            "value": "#F2FBF2",
            "type": "color"
          },
          "name": "ColorGeneralGreen5",
          "attributes": {
            "category": "color",
            "type": "general",
            "item": "green",
            "subitem": "5"
          },
          "path": [
            "color",
            "general",
            "green",
            "5"
          ]
        },
        "10": {
          "value": "#e6f7e6",
          "type": "color",
          "original": {
            "value": "#E6F7E6",
            "type": "color"
          },
          "name": "ColorGeneralGreen10",
          "attributes": {
            "category": "color",
            "type": "general",
            "item": "green",
            "subitem": "10"
          },
          "path": [
            "color",
            "general",
            "green",
            "10"
          ]
        },
        "20": {
          "value": "#ccefcc",
          "type": "color",
          "original": {
            "value": "#CCEFCC",
            "type": "color"
          },
          "name": "ColorGeneralGreen20",
          "attributes": {
            "category": "color",
            "type": "general",
            "item": "green",
            "subitem": "20"
          },
          "path": [
            "color",
            "general",
            "green",
            "20"
          ]
        },
        "50": {
          "value": "#80d880",
          "type": "color",
          "original": {
            "value": "#80D880",
            "type": "color"
          },
          "name": "ColorGeneralGreen50",
          "attributes": {
            "category": "color",
            "type": "general",
            "item": "green",
            "subitem": "50"
          },
          "path": [
            "color",
            "general",
            "green",
            "50"
          ]
        },
        "75": {
          "value": "#40c340",
          "type": "color",
          "original": {
            "value": "#40C340",
            "type": "color"
          },
          "name": "ColorGeneralGreen75",
          "attributes": {
            "category": "color",
            "type": "general",
            "item": "green",
            "subitem": "75"
          },
          "path": [
            "color",
            "general",
            "green",
            "75"
          ]
        },
        "100": {
          "value": "#00af00",
          "type": "color",
          "original": {
            "value": "#00AF00",
            "type": "color"
          },
          "name": "ColorGeneralGreen100",
          "attributes": {
            "category": "color",
            "type": "general",
            "item": "green",
            "subitem": "100"
          },
          "path": [
            "color",
            "general",
            "green",
            "100"
          ]
        }
      },
      "yellow": {
        "5": {
          "value": "#fffcf2",
          "type": "color",
          "original": {
            "value": "#FFFCF2",
            "type": "color"
          },
          "name": "ColorGeneralYellow5",
          "attributes": {
            "category": "color",
            "type": "general",
            "item": "yellow",
            "subitem": "5"
          },
          "path": [
            "color",
            "general",
            "yellow",
            "5"
          ]
        },
        "10": {
          "value": "#fffae6",
          "type": "color",
          "original": {
            "value": "#FFFAE6",
            "type": "color"
          },
          "name": "ColorGeneralYellow10",
          "attributes": {
            "category": "color",
            "type": "general",
            "item": "yellow",
            "subitem": "10"
          },
          "path": [
            "color",
            "general",
            "yellow",
            "10"
          ]
        },
        "20": {
          "value": "#fff4cc",
          "type": "color",
          "original": {
            "value": "#FFF4CC",
            "type": "color"
          },
          "name": "ColorGeneralYellow20",
          "attributes": {
            "category": "color",
            "type": "general",
            "item": "yellow",
            "subitem": "20"
          },
          "path": [
            "color",
            "general",
            "yellow",
            "20"
          ]
        },
        "50": {
          "value": "#ffe480",
          "type": "color",
          "original": {
            "value": "#FFE480",
            "type": "color"
          },
          "name": "ColorGeneralYellow50",
          "attributes": {
            "category": "color",
            "type": "general",
            "item": "yellow",
            "subitem": "50"
          },
          "path": [
            "color",
            "general",
            "yellow",
            "50"
          ]
        },
        "75": {
          "value": "#ffd640",
          "type": "color",
          "original": {
            "value": "#FFD640",
            "type": "color"
          },
          "name": "ColorGeneralYellow75",
          "attributes": {
            "category": "color",
            "type": "general",
            "item": "yellow",
            "subitem": "75"
          },
          "path": [
            "color",
            "general",
            "yellow",
            "75"
          ]
        },
        "100": {
          "value": "#ffc800",
          "type": "color",
          "original": {
            "value": "#FFC800",
            "type": "color"
          },
          "name": "ColorGeneralYellow100",
          "attributes": {
            "category": "color",
            "type": "general",
            "item": "yellow",
            "subitem": "100"
          },
          "path": [
            "color",
            "general",
            "yellow",
            "100"
          ]
        }
      },
      "red": {
        "5": {
          "value": "#fff2f2",
          "type": "color",
          "original": {
            "value": "#FFF2F2",
            "type": "color"
          },
          "name": "ColorGeneralRed5",
          "attributes": {
            "category": "color",
            "type": "general",
            "item": "red",
            "subitem": "5"
          },
          "path": [
            "color",
            "general",
            "red",
            "5"
          ]
        },
        "10": {
          "value": "#ffe6e6",
          "type": "color",
          "original": {
            "value": "#FFE6E6",
            "type": "color"
          },
          "name": "ColorGeneralRed10",
          "attributes": {
            "category": "color",
            "type": "general",
            "item": "red",
            "subitem": "10"
          },
          "path": [
            "color",
            "general",
            "red",
            "10"
          ]
        },
        "20": {
          "value": "#ffcccc",
          "type": "color",
          "original": {
            "value": "#FFCCCC",
            "type": "color"
          },
          "name": "ColorGeneralRed20",
          "attributes": {
            "category": "color",
            "type": "general",
            "item": "red",
            "subitem": "20"
          },
          "path": [
            "color",
            "general",
            "red",
            "20"
          ]
        },
        "50": {
          "value": "#ff8080",
          "type": "color",
          "original": {
            "value": "#FF8080",
            "type": "color"
          },
          "name": "ColorGeneralRed50",
          "attributes": {
            "category": "color",
            "type": "general",
            "item": "red",
            "subitem": "50"
          },
          "path": [
            "color",
            "general",
            "red",
            "50"
          ]
        },
        "75": {
          "value": "#ff4040",
          "type": "color",
          "original": {
            "value": "#FF4040",
            "type": "color"
          },
          "name": "ColorGeneralRed75",
          "attributes": {
            "category": "color",
            "type": "general",
            "item": "red",
            "subitem": "75"
          },
          "path": [
            "color",
            "general",
            "red",
            "75"
          ]
        },
        "100": {
          "value": "#ff0000",
          "type": "color",
          "original": {
            "value": "#FF0000",
            "type": "color"
          },
          "name": "ColorGeneralRed100",
          "attributes": {
            "category": "color",
            "type": "general",
            "item": "red",
            "subitem": "100"
          },
          "path": [
            "color",
            "general",
            "red",
            "100"
          ]
        }
      },
      "gray": {
        "5": {
          "value": "#d5d6d2",
          "type": "color",
          "original": {
            "value": "#D5D6D2",
            "type": "color"
          },
          "name": "ColorGeneralGray5",
          "attributes": {
            "category": "color",
            "type": "general",
            "item": "gray",
            "subitem": "5"
          },
          "path": [
            "color",
            "general",
            "gray",
            "5"
          ]
        },
        "10": {
          "value": "#f3f3f3",
          "type": "color",
          "original": {
            "value": "#F3F3F3",
            "type": "color"
          },
          "name": "ColorGeneralGray10",
          "attributes": {
            "category": "color",
            "type": "general",
            "item": "gray",
            "subitem": "10"
          },
          "path": [
            "color",
            "general",
            "gray",
            "10"
          ]
        },
        "20": {
          "value": "#e6e6e6",
          "type": "color",
          "original": {
            "value": "#E6E6E6",
            "type": "color"
          },
          "name": "ColorGeneralGray20",
          "attributes": {
            "category": "color",
            "type": "general",
            "item": "gray",
            "subitem": "20"
          },
          "path": [
            "color",
            "general",
            "gray",
            "20"
          ]
        },
        "50": {
          "value": "#c0c0c0",
          "type": "color",
          "original": {
            "value": "#C0C0C0",
            "type": "color"
          },
          "name": "ColorGeneralGray50",
          "attributes": {
            "category": "color",
            "type": "general",
            "item": "gray",
            "subitem": "50"
          },
          "path": [
            "color",
            "general",
            "gray",
            "50"
          ]
        },
        "75": {
          "value": "#a0a0a0",
          "type": "color",
          "original": {
            "value": "#A0A0A0",
            "type": "color"
          },
          "name": "ColorGeneralGray75",
          "attributes": {
            "category": "color",
            "type": "general",
            "item": "gray",
            "subitem": "75"
          },
          "path": [
            "color",
            "general",
            "gray",
            "75"
          ]
        },
        "100": {
          "value": "#808080",
          "type": "color",
          "original": {
            "value": "#808080",
            "type": "color"
          },
          "name": "ColorGeneralGray100",
          "attributes": {
            "category": "color",
            "type": "general",
            "item": "gray",
            "subitem": "100"
          },
          "path": [
            "color",
            "general",
            "gray",
            "100"
          ]
        }
      }
    },
    "klr": {
      "black": {
        "100": {
          "value": "#2a2623",
          "type": "color",
          "original": {
            "value": "#2A2623",
            "type": "color"
          },
          "name": "ColorKlrBlack100",
          "attributes": {
            "category": "color",
            "type": "klr",
            "item": "black",
            "subitem": "100"
          },
          "path": [
            "color",
            "klr",
            "black",
            "100"
          ]
        }
      },
      "white": {
        "100": {
          "value": "#ffffff",
          "type": "color",
          "original": {
            "value": "#ffffff",
            "type": "color"
          },
          "name": "ColorKlrWhite100",
          "attributes": {
            "category": "color",
            "type": "klr",
            "item": "white",
            "subitem": "100"
          },
          "path": [
            "color",
            "klr",
            "white",
            "100"
          ]
        }
      },
      "gray": {
        "2": {
          "value": "#fcfcfc",
          "type": "color",
          "original": {
            "value": "#FCFCFC",
            "type": "color"
          },
          "name": "ColorKlrGray2",
          "attributes": {
            "category": "color",
            "type": "klr",
            "item": "gray",
            "subitem": "2"
          },
          "path": [
            "color",
            "klr",
            "gray",
            "2"
          ]
        },
        "5": {
          "value": "#f5f5f5",
          "type": "color",
          "original": {
            "value": "#F5F5F5",
            "type": "color"
          },
          "name": "ColorKlrGray5",
          "attributes": {
            "category": "color",
            "type": "klr",
            "item": "gray",
            "subitem": "5"
          },
          "path": [
            "color",
            "klr",
            "gray",
            "5"
          ]
        },
        "15": {
          "value": "#e3e3e3",
          "type": "color",
          "original": {
            "value": "#E3E3E3",
            "type": "color"
          },
          "name": "ColorKlrGray15",
          "attributes": {
            "category": "color",
            "type": "klr",
            "item": "gray",
            "subitem": "15"
          },
          "path": [
            "color",
            "klr",
            "gray",
            "15"
          ]
        },
        "50": {
          "value": "#939598",
          "type": "color",
          "original": {
            "value": "#939598",
            "type": "color"
          },
          "name": "ColorKlrGray50",
          "attributes": {
            "category": "color",
            "type": "klr",
            "item": "gray",
            "subitem": "50"
          },
          "path": [
            "color",
            "klr",
            "gray",
            "50"
          ]
        },
        "100": {
          "value": "#414040",
          "type": "color",
          "original": {
            "value": "#414040",
            "type": "color"
          },
          "name": "ColorKlrGray100",
          "attributes": {
            "category": "color",
            "type": "klr",
            "item": "gray",
            "subitem": "100"
          },
          "path": [
            "color",
            "klr",
            "gray",
            "100"
          ]
        }
      },
      "red": {
        "10": {
          "value": "#f9e7eb",
          "type": "color",
          "original": {
            "value": "#F9E7EB",
            "type": "color"
          },
          "name": "ColorKlrRed10",
          "attributes": {
            "category": "color",
            "type": "klr",
            "item": "red",
            "subitem": "10"
          },
          "path": [
            "color",
            "klr",
            "red",
            "10"
          ]
        },
        "20": {
          "value": "#f2ced6",
          "type": "color",
          "original": {
            "value": "#F2CED6",
            "type": "color"
          },
          "name": "ColorKlrRed20",
          "attributes": {
            "category": "color",
            "type": "klr",
            "item": "red",
            "subitem": "20"
          },
          "path": [
            "color",
            "klr",
            "red",
            "20"
          ]
        },
        "50": {
          "value": "#e08698",
          "type": "color",
          "original": {
            "value": "#E08698",
            "type": "color"
          },
          "name": "ColorKlrRed50",
          "attributes": {
            "category": "color",
            "type": "klr",
            "item": "red",
            "subitem": "50"
          },
          "path": [
            "color",
            "klr",
            "red",
            "50"
          ]
        },
        "100": {
          "value": "#c00c30",
          "type": "color",
          "original": {
            "value": "#C00C30",
            "type": "color"
          },
          "name": "ColorKlrRed100",
          "attributes": {
            "category": "color",
            "type": "klr",
            "item": "red",
            "subitem": "100"
          },
          "path": [
            "color",
            "klr",
            "red",
            "100"
          ]
        }
      }
    },
    "me": {
      "black": {
        "100": {
          "value": "#231f20",
          "type": "color",
          "original": {
            "value": "#231F20",
            "type": "color"
          },
          "name": "ColorMeBlack100",
          "attributes": {
            "category": "color",
            "type": "me",
            "item": "black",
            "subitem": "100"
          },
          "path": [
            "color",
            "me",
            "black",
            "100"
          ]
        }
      },
      "white": {
        "100": {
          "value": "#ffffff",
          "type": "color",
          "original": {
            "value": "#ffffff",
            "type": "color"
          },
          "name": "ColorMeWhite100",
          "attributes": {
            "category": "color",
            "type": "me",
            "item": "white",
            "subitem": "100"
          },
          "path": [
            "color",
            "me",
            "white",
            "100"
          ]
        }
      },
      "gray": {
        "2": {
          "value": "#fcfcfc",
          "type": "color",
          "original": {
            "value": "#FCFCFC",
            "type": "color"
          },
          "name": "ColorMeGray2",
          "attributes": {
            "category": "color",
            "type": "me",
            "item": "gray",
            "subitem": "2"
          },
          "path": [
            "color",
            "me",
            "gray",
            "2"
          ]
        },
        "5": {
          "value": "#f5f5f5",
          "type": "color",
          "original": {
            "value": "#F5F5F5",
            "type": "color"
          },
          "name": "ColorMeGray5",
          "attributes": {
            "category": "color",
            "type": "me",
            "item": "gray",
            "subitem": "5"
          },
          "path": [
            "color",
            "me",
            "gray",
            "5"
          ]
        },
        "15": {
          "value": "#e3e3e3",
          "type": "color",
          "original": {
            "value": "#E3E3E3",
            "type": "color"
          },
          "name": "ColorMeGray15",
          "attributes": {
            "category": "color",
            "type": "me",
            "item": "gray",
            "subitem": "15"
          },
          "path": [
            "color",
            "me",
            "gray",
            "15"
          ]
        },
        "50": {
          "value": "#939598",
          "type": "color",
          "original": {
            "value": "#939598",
            "type": "color"
          },
          "name": "ColorMeGray50",
          "attributes": {
            "category": "color",
            "type": "me",
            "item": "gray",
            "subitem": "50"
          },
          "path": [
            "color",
            "me",
            "gray",
            "50"
          ]
        },
        "100": {
          "value": "#414040",
          "type": "color",
          "original": {
            "value": "#414040",
            "type": "color"
          },
          "name": "ColorMeGray100",
          "attributes": {
            "category": "color",
            "type": "me",
            "item": "gray",
            "subitem": "100"
          },
          "path": [
            "color",
            "me",
            "gray",
            "100"
          ]
        }
      },
      "red": {
        "10": {
          "value": "#fbe8e9",
          "type": "color",
          "original": {
            "value": "#FBE8E9",
            "type": "color"
          },
          "name": "ColorMeRed10",
          "attributes": {
            "category": "color",
            "type": "me",
            "item": "red",
            "subitem": "10"
          },
          "path": [
            "color",
            "me",
            "red",
            "10"
          ]
        },
        "20": {
          "value": "#f7d1d2",
          "type": "color",
          "original": {
            "value": "#F7D1D2",
            "type": "color"
          },
          "name": "ColorMeRed20",
          "attributes": {
            "category": "color",
            "type": "me",
            "item": "red",
            "subitem": "20"
          },
          "path": [
            "color",
            "me",
            "red",
            "20"
          ]
        },
        "50": {
          "value": "#eb8c90",
          "type": "color",
          "original": {
            "value": "#EB8C90",
            "type": "color"
          },
          "name": "ColorMeRed50",
          "attributes": {
            "category": "color",
            "type": "me",
            "item": "red",
            "subitem": "50"
          },
          "path": [
            "color",
            "me",
            "red",
            "50"
          ]
        },
        "100": {
          "value": "#d71920",
          "type": "color",
          "original": {
            "value": "#D71920",
            "type": "color"
          },
          "name": "ColorMeRed100",
          "attributes": {
            "category": "color",
            "type": "me",
            "item": "red",
            "subitem": "100"
          },
          "path": [
            "color",
            "me",
            "red",
            "100"
          ]
        }
      },
      "red-light": {
        "100": {
          "value": "#ff6853",
          "type": "color",
          "original": {
            "value": "#FF6853",
            "type": "color"
          },
          "name": "ColorMeRedLight100",
          "attributes": {
            "category": "color",
            "type": "me",
            "item": "red-light",
            "subitem": "100"
          },
          "path": [
            "color",
            "me",
            "red-light",
            "100"
          ]
        }
      },
      "red-dark": {
        "100": {
          "value": "#b70007",
          "type": "color",
          "original": {
            "value": "#B70007",
            "type": "color"
          },
          "name": "ColorMeRedDark100",
          "attributes": {
            "category": "color",
            "type": "me",
            "item": "red-dark",
            "subitem": "100"
          },
          "path": [
            "color",
            "me",
            "red-dark",
            "100"
          ]
        }
      },
      "cyan": {
        "10": {
          "value": "#e6f9ff",
          "type": "color",
          "original": {
            "value": "#E6F9FF",
            "type": "color"
          },
          "name": "ColorMeCyan10",
          "attributes": {
            "category": "color",
            "type": "me",
            "item": "cyan",
            "subitem": "10"
          },
          "path": [
            "color",
            "me",
            "cyan",
            "10"
          ]
        },
        "20": {
          "value": "#ccf1ff",
          "type": "color",
          "original": {
            "value": "#CCF1FF",
            "type": "color"
          },
          "name": "ColorMeCyan20",
          "attributes": {
            "category": "color",
            "type": "me",
            "item": "cyan",
            "subitem": "20"
          },
          "path": [
            "color",
            "me",
            "cyan",
            "20"
          ]
        },
        "50": {
          "value": "#80ddff",
          "type": "color",
          "original": {
            "value": "#80DDFF",
            "type": "color"
          },
          "name": "ColorMeCyan50",
          "attributes": {
            "category": "color",
            "type": "me",
            "item": "cyan",
            "subitem": "50"
          },
          "path": [
            "color",
            "me",
            "cyan",
            "50"
          ]
        },
        "100": {
          "value": "#00baff",
          "type": "color",
          "original": {
            "value": "#00BAFF",
            "type": "color"
          },
          "name": "ColorMeCyan100",
          "attributes": {
            "category": "color",
            "type": "me",
            "item": "cyan",
            "subitem": "100"
          },
          "path": [
            "color",
            "me",
            "cyan",
            "100"
          ]
        }
      }
    },
    "rwl": {
      "black": {
        "100": {
          "value": "#000000",
          "type": "color",
          "original": {
            "value": "#000000",
            "type": "color"
          },
          "name": "ColorRwlBlack100",
          "attributes": {
            "category": "color",
            "type": "rwl",
            "item": "black",
            "subitem": "100"
          },
          "path": [
            "color",
            "rwl",
            "black",
            "100"
          ]
        }
      },
      "white": {
        "100": {
          "value": "#ffffff",
          "type": "color",
          "original": {
            "value": "#ffffff",
            "type": "color"
          },
          "name": "ColorRwlWhite100",
          "attributes": {
            "category": "color",
            "type": "rwl",
            "item": "white",
            "subitem": "100"
          },
          "path": [
            "color",
            "rwl",
            "white",
            "100"
          ]
        }
      },
      "blue": {
        "10": {
          "value": "#e5eaef",
          "type": "color",
          "original": {
            "value": "#E5EAEF",
            "type": "color"
          },
          "name": "ColorRwlBlue10",
          "attributes": {
            "category": "color",
            "type": "rwl",
            "item": "blue",
            "subitem": "10"
          },
          "path": [
            "color",
            "rwl",
            "blue",
            "10"
          ]
        },
        "20": {
          "value": "#cdd6e4",
          "type": "color",
          "original": {
            "value": "#CDD6E4",
            "type": "color"
          },
          "name": "ColorRwlBlue20",
          "attributes": {
            "category": "color",
            "type": "rwl",
            "item": "blue",
            "subitem": "20"
          },
          "path": [
            "color",
            "rwl",
            "blue",
            "20"
          ]
        },
        "80": {
          "value": "#3e6295",
          "type": "color",
          "original": {
            "value": "#3E6295",
            "type": "color"
          },
          "name": "ColorRwlBlue80",
          "attributes": {
            "category": "color",
            "type": "rwl",
            "item": "blue",
            "subitem": "80"
          },
          "path": [
            "color",
            "rwl",
            "blue",
            "80"
          ]
        },
        "90": {
          "value": "#1c5188",
          "type": "color",
          "original": {
            "value": "#1C5188",
            "type": "color"
          },
          "name": "ColorRwlBlue90",
          "attributes": {
            "category": "color",
            "type": "rwl",
            "item": "blue",
            "subitem": "90"
          },
          "path": [
            "color",
            "rwl",
            "blue",
            "90"
          ]
        },
        "100": {
          "value": "#003366",
          "type": "color",
          "original": {
            "value": " #003366",
            "type": "color"
          },
          "name": "ColorRwlBlue100",
          "attributes": {
            "category": "color",
            "type": "rwl",
            "item": "blue",
            "subitem": "100"
          },
          "path": [
            "color",
            "rwl",
            "blue",
            "100"
          ]
        }
      },
      "gray": {
        "2": {
          "value": "#fcfcfc",
          "type": "color",
          "original": {
            "value": "#FCFCFC",
            "type": "color"
          },
          "name": "ColorRwlGray2",
          "attributes": {
            "category": "color",
            "type": "rwl",
            "item": "gray",
            "subitem": "2"
          },
          "path": [
            "color",
            "rwl",
            "gray",
            "2"
          ]
        },
        "5": {
          "value": "#f5f5f5",
          "type": "color",
          "original": {
            "value": "#f5f5f5",
            "type": "color"
          },
          "name": "ColorRwlGray5",
          "attributes": {
            "category": "color",
            "type": "rwl",
            "item": "gray",
            "subitem": "5"
          },
          "path": [
            "color",
            "rwl",
            "gray",
            "5"
          ]
        },
        "15": {
          "value": "#d5d6d2",
          "type": "color",
          "original": {
            "value": "#D5D6D2",
            "type": "color"
          },
          "name": "ColorRwlGray15",
          "attributes": {
            "category": "color",
            "type": "rwl",
            "item": "gray",
            "subitem": "15"
          },
          "path": [
            "color",
            "rwl",
            "gray",
            "15"
          ]
        },
        "50": {
          "value": "#9a9b9c",
          "type": "color",
          "original": {
            "value": "#9a9b9c",
            "type": "color"
          },
          "name": "ColorRwlGray50",
          "attributes": {
            "category": "color",
            "type": "rwl",
            "item": "gray",
            "subitem": "50"
          },
          "path": [
            "color",
            "rwl",
            "gray",
            "50"
          ]
        },
        "100": {
          "value": "#68676c",
          "type": "color",
          "original": {
            "value": "#68676C",
            "type": "color"
          },
          "name": "ColorRwlGray100",
          "attributes": {
            "category": "color",
            "type": "rwl",
            "item": "gray",
            "subitem": "100"
          },
          "path": [
            "color",
            "rwl",
            "gray",
            "100"
          ]
        }
      },
      "orange": {
        "10": {
          "value": "#fff4e6",
          "type": "color",
          "original": {
            "value": "#FFF4E6",
            "type": "color"
          },
          "name": "ColorRwlOrange10",
          "attributes": {
            "category": "color",
            "type": "rwl",
            "item": "orange",
            "subitem": "10"
          },
          "path": [
            "color",
            "rwl",
            "orange",
            "10"
          ]
        },
        "20": {
          "value": "#ffe8cc",
          "type": "color",
          "original": {
            "value": "#FFE8CC",
            "type": "color"
          },
          "name": "ColorRwlOrange20",
          "attributes": {
            "category": "color",
            "type": "rwl",
            "item": "orange",
            "subitem": "20"
          },
          "path": [
            "color",
            "rwl",
            "orange",
            "20"
          ]
        },
        "70": {
          "value": "#ffae4d",
          "type": "color",
          "original": {
            "value": "#FFAE4D",
            "type": "color"
          },
          "name": "ColorRwlOrange70",
          "attributes": {
            "category": "color",
            "type": "rwl",
            "item": "orange",
            "subitem": "70"
          },
          "path": [
            "color",
            "rwl",
            "orange",
            "70"
          ]
        },
        "100": {
          "value": "#ff8a00",
          "type": "color",
          "original": {
            "value": "#FF8A00",
            "type": "color"
          },
          "name": "ColorRwlOrange100",
          "attributes": {
            "category": "color",
            "type": "rwl",
            "item": "orange",
            "subitem": "100"
          },
          "path": [
            "color",
            "rwl",
            "orange",
            "100"
          ]
        }
      },
      "vermillion": {
        "100": {
          "value": "#f05600",
          "type": "color",
          "original": {
            "value": "#F05600",
            "type": "color"
          },
          "name": "ColorRwlVermillion100",
          "attributes": {
            "category": "color",
            "type": "rwl",
            "item": "vermillion",
            "subitem": "100"
          },
          "path": [
            "color",
            "rwl",
            "vermillion",
            "100"
          ]
        }
      },
      "red": {
        "10": {
          "value": "#fceceb",
          "type": "color",
          "original": {
            "value": "#FCECEB",
            "type": "color"
          },
          "name": "ColorRwlRed10",
          "attributes": {
            "category": "color",
            "type": "rwl",
            "item": "red",
            "subitem": "10"
          },
          "path": [
            "color",
            "rwl",
            "red",
            "10"
          ]
        },
        "20": {
          "value": "#f8d7d6",
          "type": "color",
          "original": {
            "value": "#F8D7D6",
            "type": "color"
          },
          "name": "ColorRwlRed20",
          "attributes": {
            "category": "color",
            "type": "rwl",
            "item": "red",
            "subitem": "20"
          },
          "path": [
            "color",
            "rwl",
            "red",
            "20"
          ]
        },
        "50": {
          "value": "#ef9c98",
          "type": "color",
          "original": {
            "value": "#EF9C98",
            "type": "color"
          },
          "name": "ColorRwlRed50",
          "attributes": {
            "category": "color",
            "type": "rwl",
            "item": "red",
            "subitem": "50"
          },
          "path": [
            "color",
            "rwl",
            "red",
            "50"
          ]
        },
        "100": {
          "value": "#de3831",
          "type": "color",
          "original": {
            "value": "#DE3831",
            "type": "color"
          },
          "name": "ColorRwlRed100",
          "attributes": {
            "category": "color",
            "type": "rwl",
            "item": "red",
            "subitem": "100"
          },
          "path": [
            "color",
            "rwl",
            "red",
            "100"
          ]
        }
      },
      "green": {
        "10": {
          "value": "#f6fbe6",
          "type": "color",
          "original": {
            "value": "#F6FBE6",
            "type": "color"
          },
          "name": "ColorRwlGreen10",
          "attributes": {
            "category": "color",
            "type": "rwl",
            "item": "green",
            "subitem": "10"
          },
          "path": [
            "color",
            "rwl",
            "green",
            "10"
          ]
        },
        "20": {
          "value": "#ecf6cc",
          "type": "color",
          "original": {
            "value": "#ECF6CC",
            "type": "color"
          },
          "name": "ColorRwlGreen20",
          "attributes": {
            "category": "color",
            "type": "rwl",
            "item": "green",
            "subitem": "20"
          },
          "path": [
            "color",
            "rwl",
            "green",
            "20"
          ]
        },
        "50": {
          "value": "#c7d673",
          "type": "color",
          "original": {
            "value": "#C7D673",
            "type": "color"
          },
          "name": "ColorRwlGreen50",
          "attributes": {
            "category": "color",
            "type": "rwl",
            "item": "green",
            "subitem": "50"
          },
          "path": [
            "color",
            "rwl",
            "green",
            "50"
          ]
        },
        "100": {
          "value": "#a2d100",
          "type": "color",
          "original": {
            "value": "#A2D100",
            "type": "color"
          },
          "name": "ColorRwlGreen100",
          "attributes": {
            "category": "color",
            "type": "rwl",
            "item": "green",
            "subitem": "100"
          },
          "path": [
            "color",
            "rwl",
            "green",
            "100"
          ]
        }
      },
      "cyan": {
        "10": {
          "value": "#e6f9ff",
          "type": "color",
          "original": {
            "value": "#E6F9FF",
            "type": "color"
          },
          "name": "ColorRwlCyan10",
          "attributes": {
            "category": "color",
            "type": "rwl",
            "item": "cyan",
            "subitem": "10"
          },
          "path": [
            "color",
            "rwl",
            "cyan",
            "10"
          ]
        },
        "20": {
          "value": "#ccf1ff",
          "type": "color",
          "original": {
            "value": "#CCF1FF",
            "type": "color"
          },
          "name": "ColorRwlCyan20",
          "attributes": {
            "category": "color",
            "type": "rwl",
            "item": "cyan",
            "subitem": "20"
          },
          "path": [
            "color",
            "rwl",
            "cyan",
            "20"
          ]
        },
        "50": {
          "value": "#80ddff",
          "type": "color",
          "original": {
            "value": "#80DDFF",
            "type": "color"
          },
          "name": "ColorRwlCyan50",
          "attributes": {
            "category": "color",
            "type": "rwl",
            "item": "cyan",
            "subitem": "50"
          },
          "path": [
            "color",
            "rwl",
            "cyan",
            "50"
          ]
        },
        "100": {
          "value": "#00baff",
          "type": "color",
          "original": {
            "value": "#00BAFF",
            "type": "color"
          },
          "name": "ColorRwlCyan100",
          "attributes": {
            "category": "color",
            "type": "rwl",
            "item": "cyan",
            "subitem": "100"
          },
          "path": [
            "color",
            "rwl",
            "cyan",
            "100"
          ]
        }
      },
      "steel": {
        "10": {
          "value": "#f0f6fa",
          "type": "color",
          "original": {
            "value": "#F0F6FA",
            "type": "color"
          },
          "name": "ColorRwlSteel10",
          "attributes": {
            "category": "color",
            "type": "rwl",
            "item": "steel",
            "subitem": "10"
          },
          "path": [
            "color",
            "rwl",
            "steel",
            "10"
          ]
        },
        "20": {
          "value": "#e0ecf4",
          "type": "color",
          "original": {
            "value": "#E0ECF4",
            "type": "color"
          },
          "name": "ColorRwlSteel20",
          "attributes": {
            "category": "color",
            "type": "rwl",
            "item": "steel",
            "subitem": "20"
          },
          "path": [
            "color",
            "rwl",
            "steel",
            "20"
          ]
        },
        "50": {
          "value": "#b2d0e4",
          "type": "color",
          "original": {
            "value": "#B2D0E4",
            "type": "color"
          },
          "name": "ColorRwlSteel50",
          "attributes": {
            "category": "color",
            "type": "rwl",
            "item": "steel",
            "subitem": "50"
          },
          "path": [
            "color",
            "rwl",
            "steel",
            "50"
          ]
        },
        "100": {
          "value": "#64a0c8",
          "type": "color",
          "original": {
            "value": "#64A0C8",
            "type": "color"
          },
          "name": "ColorRwlSteel100",
          "attributes": {
            "category": "color",
            "type": "rwl",
            "item": "steel",
            "subitem": "100"
          },
          "path": [
            "color",
            "rwl",
            "steel",
            "100"
          ]
        }
      },
      "gold": {
        "10": {
          "value": "#fbf9f5",
          "type": "color",
          "original": {
            "value": "#FBF9F5",
            "type": "color"
          },
          "name": "ColorRwlGold10",
          "attributes": {
            "category": "color",
            "type": "rwl",
            "item": "gold",
            "subitem": "10"
          },
          "path": [
            "color",
            "rwl",
            "gold",
            "10"
          ]
        },
        "20": {
          "value": "#f6f2ea",
          "type": "color",
          "original": {
            "value": "#F6F2EA",
            "type": "color"
          },
          "name": "ColorRwlGold20",
          "attributes": {
            "category": "color",
            "type": "rwl",
            "item": "gold",
            "subitem": "20"
          },
          "path": [
            "color",
            "rwl",
            "gold",
            "20"
          ]
        },
        "50": {
          "value": "#e9dfcb",
          "type": "color",
          "original": {
            "value": "#E9DFCB",
            "type": "color"
          },
          "name": "ColorRwlGold50",
          "attributes": {
            "category": "color",
            "type": "rwl",
            "item": "gold",
            "subitem": "50"
          },
          "path": [
            "color",
            "rwl",
            "gold",
            "50"
          ]
        },
        "100": {
          "value": "#d3bf96",
          "type": "color",
          "original": {
            "value": "#D3BF96",
            "type": "color"
          },
          "name": "ColorRwlGold100",
          "attributes": {
            "category": "color",
            "type": "rwl",
            "item": "gold",
            "subitem": "100"
          },
          "path": [
            "color",
            "rwl",
            "gold",
            "100"
          ]
        }
      }
    }
  },
  "font-weight": {
    "light": {
      "value": "300",
      "type": "font-weight",
      "original": {
        "value": "300",
        "type": "font-weight"
      },
      "name": "FontWeightLight",
      "attributes": {
        "category": "font-weight",
        "type": "light"
      },
      "path": [
        "font-weight",
        "light"
      ]
    },
    "regular": {
      "value": "400",
      "type": "font-weight",
      "original": {
        "value": "400",
        "type": "font-weight"
      },
      "name": "FontWeightRegular",
      "attributes": {
        "category": "font-weight",
        "type": "regular"
      },
      "path": [
        "font-weight",
        "regular"
      ]
    },
    "medium": {
      "value": "500",
      "type": "font-weight",
      "original": {
        "value": "500",
        "type": "font-weight"
      },
      "name": "FontWeightMedium",
      "attributes": {
        "category": "font-weight",
        "type": "medium"
      },
      "path": [
        "font-weight",
        "medium"
      ]
    },
    "semibold": {
      "value": "600",
      "type": "font-weight",
      "original": {
        "value": "600",
        "type": "font-weight"
      },
      "name": "FontWeightSemibold",
      "attributes": {
        "category": "font-weight",
        "type": "semibold"
      },
      "path": [
        "font-weight",
        "semibold"
      ]
    },
    "bold": {
      "value": "700",
      "type": "font-weight",
      "original": {
        "value": "700",
        "type": "font-weight"
      },
      "name": "FontWeightBold",
      "attributes": {
        "category": "font-weight",
        "type": "bold"
      },
      "path": [
        "font-weight",
        "bold"
      ]
    }
  },
  "spacing": {
    "1": {
      "value": "1px",
      "type": "spacing",
      "original": {
        "value": "1px",
        "type": "spacing"
      },
      "name": "Spacing1",
      "attributes": {
        "category": "spacing",
        "type": "1"
      },
      "path": [
        "spacing",
        "1"
      ]
    },
    "2": {
      "value": "2px",
      "type": "spacing",
      "original": {
        "value": "2px",
        "type": "spacing"
      },
      "name": "Spacing2",
      "attributes": {
        "category": "spacing",
        "type": "2"
      },
      "path": [
        "spacing",
        "2"
      ]
    },
    "3": {
      "value": "4px",
      "type": "spacing",
      "original": {
        "value": "4px",
        "type": "spacing"
      },
      "name": "Spacing3",
      "attributes": {
        "category": "spacing",
        "type": "3"
      },
      "path": [
        "spacing",
        "3"
      ]
    },
    "4": {
      "value": "8px",
      "type": "spacing",
      "original": {
        "value": "8px",
        "type": "spacing"
      },
      "name": "Spacing4",
      "attributes": {
        "category": "spacing",
        "type": "4"
      },
      "path": [
        "spacing",
        "4"
      ]
    },
    "5": {
      "value": "16px",
      "type": "spacing",
      "original": {
        "value": "16px",
        "type": "spacing"
      },
      "name": "Spacing5",
      "attributes": {
        "category": "spacing",
        "type": "5"
      },
      "path": [
        "spacing",
        "5"
      ]
    },
    "6": {
      "value": "32px",
      "type": "spacing",
      "original": {
        "value": "32px",
        "type": "spacing"
      },
      "name": "Spacing6",
      "attributes": {
        "category": "spacing",
        "type": "6"
      },
      "path": [
        "spacing",
        "6"
      ]
    },
    "7": {
      "value": "40px",
      "type": "spacing",
      "original": {
        "value": "40px",
        "type": "spacing"
      },
      "name": "Spacing7",
      "attributes": {
        "category": "spacing",
        "type": "7"
      },
      "path": [
        "spacing",
        "7"
      ]
    },
    "8": {
      "value": "48px",
      "type": "spacing",
      "original": {
        "value": "48px",
        "type": "spacing"
      },
      "name": "Spacing8",
      "attributes": {
        "category": "spacing",
        "type": "8"
      },
      "path": [
        "spacing",
        "8"
      ]
    },
    "9": {
      "value": "64px",
      "type": "spacing",
      "original": {
        "value": "64px",
        "type": "spacing"
      },
      "name": "Spacing9",
      "attributes": {
        "category": "spacing",
        "type": "9"
      },
      "path": [
        "spacing",
        "9"
      ]
    },
    "10": {
      "value": "128px",
      "type": "spacing",
      "original": {
        "value": "128px",
        "type": "spacing"
      },
      "name": "Spacing10",
      "attributes": {
        "category": "spacing",
        "type": "10"
      },
      "path": [
        "spacing",
        "10"
      ]
    },
    "11": {
      "value": "256px",
      "type": "spacing",
      "original": {
        "value": "256px",
        "type": "spacing"
      },
      "name": "Spacing11",
      "attributes": {
        "category": "spacing",
        "type": "11"
      },
      "path": [
        "spacing",
        "11"
      ]
    }
  },
  "border": {
    "klr": {
      "solid": {
        "1": {
          "value": "1px solid #000000",
          "type": "border",
          "original": {
            "value": "1px solid #000000",
            "type": "border"
          },
          "name": "BorderKlrSolid1",
          "attributes": {
            "category": "border",
            "type": "klr",
            "item": "solid",
            "subitem": "1"
          },
          "path": [
            "border",
            "klr",
            "solid",
            "1"
          ]
        },
        "2": {
          "value": "2px solid #000000",
          "type": "border",
          "original": {
            "value": "2px solid #000000",
            "type": "border"
          },
          "name": "BorderKlrSolid2",
          "attributes": {
            "category": "border",
            "type": "klr",
            "item": "solid",
            "subitem": "2"
          },
          "path": [
            "border",
            "klr",
            "solid",
            "2"
          ]
        },
        "3": {
          "value": "4px solid #000000",
          "type": "border",
          "original": {
            "value": "4px solid #000000",
            "type": "border"
          },
          "name": "BorderKlrSolid3",
          "attributes": {
            "category": "border",
            "type": "klr",
            "item": "solid",
            "subitem": "3"
          },
          "path": [
            "border",
            "klr",
            "solid",
            "3"
          ]
        },
        "4": {
          "value": "8px solid #000000",
          "type": "border",
          "original": {
            "value": "8px solid #000000",
            "type": "border"
          },
          "name": "BorderKlrSolid4",
          "attributes": {
            "category": "border",
            "type": "klr",
            "item": "solid",
            "subitem": "4"
          },
          "path": [
            "border",
            "klr",
            "solid",
            "4"
          ]
        }
      },
      "dash": {
        "1": {
          "value": "1px dashed #000000",
          "type": "border",
          "original": {
            "value": "1px dashed #000000",
            "type": "border"
          },
          "name": "BorderKlrDash1",
          "attributes": {
            "category": "border",
            "type": "klr",
            "item": "dash",
            "subitem": "1"
          },
          "path": [
            "border",
            "klr",
            "dash",
            "1"
          ]
        }
      }
    },
    "me": {
      "solid": {
        "1": {
          "value": "1px solid #000000",
          "type": "border",
          "original": {
            "value": "1px solid #000000",
            "type": "border"
          },
          "name": "BorderMeSolid1",
          "attributes": {
            "category": "border",
            "type": "me",
            "item": "solid",
            "subitem": "1"
          },
          "path": [
            "border",
            "me",
            "solid",
            "1"
          ]
        },
        "2": {
          "value": "2px solid #000000",
          "type": "border",
          "original": {
            "value": "2px solid #000000",
            "type": "border"
          },
          "name": "BorderMeSolid2",
          "attributes": {
            "category": "border",
            "type": "me",
            "item": "solid",
            "subitem": "2"
          },
          "path": [
            "border",
            "me",
            "solid",
            "2"
          ]
        },
        "3": {
          "value": "4px solid #000000",
          "type": "border",
          "original": {
            "value": "4px solid #000000",
            "type": "border"
          },
          "name": "BorderMeSolid3",
          "attributes": {
            "category": "border",
            "type": "me",
            "item": "solid",
            "subitem": "3"
          },
          "path": [
            "border",
            "me",
            "solid",
            "3"
          ]
        },
        "4": {
          "value": "8px solid #000000",
          "type": "border",
          "original": {
            "value": "8px solid #000000",
            "type": "border"
          },
          "name": "BorderMeSolid4",
          "attributes": {
            "category": "border",
            "type": "me",
            "item": "solid",
            "subitem": "4"
          },
          "path": [
            "border",
            "me",
            "solid",
            "4"
          ]
        }
      }
    },
    "rwl": {
      "solid": {
        "1": {
          "value": "1px solid #000000",
          "type": "border",
          "original": {
            "value": "1px solid #000000",
            "type": "border"
          },
          "name": "BorderRwlSolid1",
          "attributes": {
            "category": "border",
            "type": "rwl",
            "item": "solid",
            "subitem": "1"
          },
          "path": [
            "border",
            "rwl",
            "solid",
            "1"
          ]
        },
        "2": {
          "value": "2px solid #000000",
          "type": "border",
          "original": {
            "value": "2px solid #000000",
            "type": "border"
          },
          "name": "BorderRwlSolid2",
          "attributes": {
            "category": "border",
            "type": "rwl",
            "item": "solid",
            "subitem": "2"
          },
          "path": [
            "border",
            "rwl",
            "solid",
            "2"
          ]
        },
        "3": {
          "value": "4px solid #000000",
          "type": "border",
          "original": {
            "value": "4px solid #000000",
            "type": "border"
          },
          "name": "BorderRwlSolid3",
          "attributes": {
            "category": "border",
            "type": "rwl",
            "item": "solid",
            "subitem": "3"
          },
          "path": [
            "border",
            "rwl",
            "solid",
            "3"
          ]
        },
        "4": {
          "value": "8px solid #000000",
          "type": "border",
          "original": {
            "value": "8px solid #000000",
            "type": "border"
          },
          "name": "BorderRwlSolid4",
          "attributes": {
            "category": "border",
            "type": "rwl",
            "item": "solid",
            "subitem": "4"
          },
          "path": [
            "border",
            "rwl",
            "solid",
            "4"
          ]
        }
      },
      "dash": {
        "1": {
          "value": "1px dashed #000000",
          "type": "border",
          "original": {
            "value": "1px dashed #000000",
            "type": "border"
          },
          "name": "BorderRwlDash1",
          "attributes": {
            "category": "border",
            "type": "rwl",
            "item": "dash",
            "subitem": "1"
          },
          "path": [
            "border",
            "rwl",
            "dash",
            "1"
          ]
        }
      }
    }
  },
  "font-size": {
    "klr": {
      "headline": {
        "1": {
          "value": "48px",
          "type": "font-size",
          "original": {
            "value": "48px",
            "type": "font-size"
          },
          "name": "FontSizeKlrHeadline1",
          "attributes": {
            "category": "font-size",
            "type": "klr",
            "item": "headline",
            "subitem": "1"
          },
          "path": [
            "font-size",
            "klr",
            "headline",
            "1"
          ]
        },
        "2": {
          "value": "40px",
          "type": "font-size",
          "original": {
            "value": "40px",
            "type": "font-size"
          },
          "name": "FontSizeKlrHeadline2",
          "attributes": {
            "category": "font-size",
            "type": "klr",
            "item": "headline",
            "subitem": "2"
          },
          "path": [
            "font-size",
            "klr",
            "headline",
            "2"
          ]
        },
        "3": {
          "value": "32px",
          "type": "font-size",
          "original": {
            "value": "32px",
            "type": "font-size"
          },
          "name": "FontSizeKlrHeadline3",
          "attributes": {
            "category": "font-size",
            "type": "klr",
            "item": "headline",
            "subitem": "3"
          },
          "path": [
            "font-size",
            "klr",
            "headline",
            "3"
          ]
        },
        "4": {
          "value": "24px",
          "type": "font-size",
          "original": {
            "value": "24px",
            "type": "font-size"
          },
          "name": "FontSizeKlrHeadline4",
          "attributes": {
            "category": "font-size",
            "type": "klr",
            "item": "headline",
            "subitem": "4"
          },
          "path": [
            "font-size",
            "klr",
            "headline",
            "4"
          ]
        },
        "5": {
          "value": "20px",
          "type": "font-size",
          "original": {
            "value": "20px",
            "type": "font-size"
          },
          "name": "FontSizeKlrHeadline5",
          "attributes": {
            "category": "font-size",
            "type": "klr",
            "item": "headline",
            "subitem": "5"
          },
          "path": [
            "font-size",
            "klr",
            "headline",
            "5"
          ]
        },
        "6": {
          "value": "18px",
          "type": "font-size",
          "original": {
            "value": "18px",
            "type": "font-size"
          },
          "name": "FontSizeKlrHeadline6",
          "attributes": {
            "category": "font-size",
            "type": "klr",
            "item": "headline",
            "subitem": "6"
          },
          "path": [
            "font-size",
            "klr",
            "headline",
            "6"
          ]
        }
      },
      "body": {
        "value": "18px",
        "type": "font-size",
        "original": {
          "value": "18px",
          "type": "font-size"
        },
        "name": "FontSizeKlrBody",
        "attributes": {
          "category": "font-size",
          "type": "klr",
          "item": "body"
        },
        "path": [
          "font-size",
          "klr",
          "body"
        ]
      },
      "small": {
        "value": "14px",
        "type": "font-size",
        "original": {
          "value": "14px",
          "type": "font-size"
        },
        "name": "FontSizeKlrSmall",
        "attributes": {
          "category": "font-size",
          "type": "klr",
          "item": "small"
        },
        "path": [
          "font-size",
          "klr",
          "small"
        ]
      },
      "label": {
        "value": "16px",
        "type": "font-size",
        "original": {
          "value": "16px",
          "type": "font-size"
        },
        "name": "FontSizeKlrLabel",
        "attributes": {
          "category": "font-size",
          "type": "klr",
          "item": "label"
        },
        "path": [
          "font-size",
          "klr",
          "label"
        ]
      }
    },
    "me": {
      "headline": {
        "1": {
          "value": "48px",
          "type": "font-size",
          "original": {
            "value": "48px",
            "type": "font-size"
          },
          "name": "FontSizeMeHeadline1",
          "attributes": {
            "category": "font-size",
            "type": "me",
            "item": "headline",
            "subitem": "1"
          },
          "path": [
            "font-size",
            "me",
            "headline",
            "1"
          ]
        },
        "2": {
          "value": "40px",
          "type": "font-size",
          "original": {
            "value": "40px",
            "type": "font-size"
          },
          "name": "FontSizeMeHeadline2",
          "attributes": {
            "category": "font-size",
            "type": "me",
            "item": "headline",
            "subitem": "2"
          },
          "path": [
            "font-size",
            "me",
            "headline",
            "2"
          ]
        },
        "3": {
          "value": "32px",
          "type": "font-size",
          "original": {
            "value": "32px",
            "type": "font-size"
          },
          "name": "FontSizeMeHeadline3",
          "attributes": {
            "category": "font-size",
            "type": "me",
            "item": "headline",
            "subitem": "3"
          },
          "path": [
            "font-size",
            "me",
            "headline",
            "3"
          ]
        },
        "4": {
          "value": "24px",
          "type": "font-size",
          "original": {
            "value": "24px",
            "type": "font-size"
          },
          "name": "FontSizeMeHeadline4",
          "attributes": {
            "category": "font-size",
            "type": "me",
            "item": "headline",
            "subitem": "4"
          },
          "path": [
            "font-size",
            "me",
            "headline",
            "4"
          ]
        },
        "5": {
          "value": "20px",
          "type": "font-size",
          "original": {
            "value": "20px",
            "type": "font-size"
          },
          "name": "FontSizeMeHeadline5",
          "attributes": {
            "category": "font-size",
            "type": "me",
            "item": "headline",
            "subitem": "5"
          },
          "path": [
            "font-size",
            "me",
            "headline",
            "5"
          ]
        },
        "6": {
          "value": "18px",
          "type": "font-size",
          "original": {
            "value": "18px",
            "type": "font-size"
          },
          "name": "FontSizeMeHeadline6",
          "attributes": {
            "category": "font-size",
            "type": "me",
            "item": "headline",
            "subitem": "6"
          },
          "path": [
            "font-size",
            "me",
            "headline",
            "6"
          ]
        }
      },
      "body": {
        "value": "18px",
        "type": "font-size",
        "original": {
          "value": "18px",
          "type": "font-size"
        },
        "name": "FontSizeMeBody",
        "attributes": {
          "category": "font-size",
          "type": "me",
          "item": "body"
        },
        "path": [
          "font-size",
          "me",
          "body"
        ]
      },
      "small": {
        "value": "12px",
        "type": "font-size",
        "original": {
          "value": "12px",
          "type": "font-size"
        },
        "name": "FontSizeMeSmall",
        "attributes": {
          "category": "font-size",
          "type": "me",
          "item": "small"
        },
        "path": [
          "font-size",
          "me",
          "small"
        ]
      },
      "label": {
        "value": "14px",
        "type": "font-size",
        "original": {
          "value": "14px",
          "type": "font-size"
        },
        "name": "FontSizeMeLabel",
        "attributes": {
          "category": "font-size",
          "type": "me",
          "item": "label"
        },
        "path": [
          "font-size",
          "me",
          "label"
        ]
      }
    },
    "rwl": {
      "headline": {
        "1": {
          "value": "48px",
          "type": "font-size",
          "original": {
            "value": "48px",
            "type": "font-size"
          },
          "name": "FontSizeRwlHeadline1",
          "attributes": {
            "category": "font-size",
            "type": "rwl",
            "item": "headline",
            "subitem": "1"
          },
          "path": [
            "font-size",
            "rwl",
            "headline",
            "1"
          ]
        },
        "2": {
          "value": "40px",
          "type": "font-size",
          "original": {
            "value": "40px",
            "type": "font-size"
          },
          "name": "FontSizeRwlHeadline2",
          "attributes": {
            "category": "font-size",
            "type": "rwl",
            "item": "headline",
            "subitem": "2"
          },
          "path": [
            "font-size",
            "rwl",
            "headline",
            "2"
          ]
        },
        "3": {
          "value": "32px",
          "type": "font-size",
          "original": {
            "value": "32px",
            "type": "font-size"
          },
          "name": "FontSizeRwlHeadline3",
          "attributes": {
            "category": "font-size",
            "type": "rwl",
            "item": "headline",
            "subitem": "3"
          },
          "path": [
            "font-size",
            "rwl",
            "headline",
            "3"
          ]
        },
        "4": {
          "value": "24px",
          "type": "font-size",
          "original": {
            "value": "24px",
            "type": "font-size"
          },
          "name": "FontSizeRwlHeadline4",
          "attributes": {
            "category": "font-size",
            "type": "rwl",
            "item": "headline",
            "subitem": "4"
          },
          "path": [
            "font-size",
            "rwl",
            "headline",
            "4"
          ]
        },
        "5": {
          "value": "20px",
          "type": "font-size",
          "original": {
            "value": "20px",
            "type": "font-size"
          },
          "name": "FontSizeRwlHeadline5",
          "attributes": {
            "category": "font-size",
            "type": "rwl",
            "item": "headline",
            "subitem": "5"
          },
          "path": [
            "font-size",
            "rwl",
            "headline",
            "5"
          ]
        },
        "6": {
          "value": "18px",
          "type": "font-size",
          "original": {
            "value": "18px",
            "type": "font-size"
          },
          "name": "FontSizeRwlHeadline6",
          "attributes": {
            "category": "font-size",
            "type": "rwl",
            "item": "headline",
            "subitem": "6"
          },
          "path": [
            "font-size",
            "rwl",
            "headline",
            "6"
          ]
        }
      },
      "body": {
        "value": "16px",
        "type": "font-size",
        "original": {
          "value": "16px",
          "type": "font-size"
        },
        "name": "FontSizeRwlBody",
        "attributes": {
          "category": "font-size",
          "type": "rwl",
          "item": "body"
        },
        "path": [
          "font-size",
          "rwl",
          "body"
        ]
      },
      "small": {
        "value": "12px",
        "type": "font-size",
        "original": {
          "value": "12px",
          "type": "font-size"
        },
        "name": "FontSizeRwlSmall",
        "attributes": {
          "category": "font-size",
          "type": "rwl",
          "item": "small"
        },
        "path": [
          "font-size",
          "rwl",
          "small"
        ]
      },
      "label": {
        "value": "14px",
        "type": "font-size",
        "original": {
          "value": "14px",
          "type": "font-size"
        },
        "name": "FontSizeRwlLabel",
        "attributes": {
          "category": "font-size",
          "type": "rwl",
          "item": "label"
        },
        "path": [
          "font-size",
          "rwl",
          "label"
        ]
      }
    }
  },
  "line-height": {
    "klr": {
      "headline": {
        "1": {
          "value": "64px",
          "type": "line-height",
          "original": {
            "value": "64px",
            "type": "line-height"
          },
          "name": "LineHeightKlrHeadline1",
          "attributes": {
            "category": "line-height",
            "type": "klr",
            "item": "headline",
            "subitem": "1"
          },
          "path": [
            "line-height",
            "klr",
            "headline",
            "1"
          ]
        },
        "2": {
          "value": "56px",
          "type": "line-height",
          "original": {
            "value": "56px",
            "type": "line-height"
          },
          "name": "LineHeightKlrHeadline2",
          "attributes": {
            "category": "line-height",
            "type": "klr",
            "item": "headline",
            "subitem": "2"
          },
          "path": [
            "line-height",
            "klr",
            "headline",
            "2"
          ]
        },
        "3": {
          "value": "48px",
          "type": "line-height",
          "original": {
            "value": "48px",
            "type": "line-height"
          },
          "name": "LineHeightKlrHeadline3",
          "attributes": {
            "category": "line-height",
            "type": "klr",
            "item": "headline",
            "subitem": "3"
          },
          "path": [
            "line-height",
            "klr",
            "headline",
            "3"
          ]
        },
        "4": {
          "value": "32px",
          "type": "line-height",
          "original": {
            "value": "32px",
            "type": "line-height"
          },
          "name": "LineHeightKlrHeadline4",
          "attributes": {
            "category": "line-height",
            "type": "klr",
            "item": "headline",
            "subitem": "4"
          },
          "path": [
            "line-height",
            "klr",
            "headline",
            "4"
          ]
        },
        "5": {
          "value": "24px",
          "type": "line-height",
          "original": {
            "value": "24px",
            "type": "line-height"
          },
          "name": "LineHeightKlrHeadline5",
          "attributes": {
            "category": "line-height",
            "type": "klr",
            "item": "headline",
            "subitem": "5"
          },
          "path": [
            "line-height",
            "klr",
            "headline",
            "5"
          ]
        },
        "6": {
          "value": "24px",
          "type": "line-height",
          "original": {
            "value": "24px",
            "type": "line-height"
          },
          "name": "LineHeightKlrHeadline6",
          "attributes": {
            "category": "line-height",
            "type": "klr",
            "item": "headline",
            "subitem": "6"
          },
          "path": [
            "line-height",
            "klr",
            "headline",
            "6"
          ]
        }
      },
      "body": {
        "value": "24px",
        "type": "line-height",
        "original": {
          "value": "24px",
          "type": "line-height"
        },
        "name": "LineHeightKlrBody",
        "attributes": {
          "category": "line-height",
          "type": "klr",
          "item": "body"
        },
        "path": [
          "line-height",
          "klr",
          "body"
        ]
      },
      "small": {
        "value": "16px",
        "type": "line-height",
        "original": {
          "value": "16px",
          "type": "line-height"
        },
        "name": "LineHeightKlrSmall",
        "attributes": {
          "category": "line-height",
          "type": "klr",
          "item": "small"
        },
        "path": [
          "line-height",
          "klr",
          "small"
        ]
      },
      "label": {
        "value": "20px",
        "type": "line-height",
        "original": {
          "value": "20px",
          "type": "line-height"
        },
        "name": "LineHeightKlrLabel",
        "attributes": {
          "category": "line-height",
          "type": "klr",
          "item": "label"
        },
        "path": [
          "line-height",
          "klr",
          "label"
        ]
      }
    },
    "me": {
      "headline": {
        "1": {
          "value": "64px",
          "type": "line-height",
          "original": {
            "value": "64px",
            "type": "line-height"
          },
          "name": "LineHeightMeHeadline1",
          "attributes": {
            "category": "line-height",
            "type": "me",
            "item": "headline",
            "subitem": "1"
          },
          "path": [
            "line-height",
            "me",
            "headline",
            "1"
          ]
        },
        "2": {
          "value": "56px",
          "type": "line-height",
          "original": {
            "value": "56px",
            "type": "line-height"
          },
          "name": "LineHeightMeHeadline2",
          "attributes": {
            "category": "line-height",
            "type": "me",
            "item": "headline",
            "subitem": "2"
          },
          "path": [
            "line-height",
            "me",
            "headline",
            "2"
          ]
        },
        "3": {
          "value": "48px",
          "type": "line-height",
          "original": {
            "value": "48px",
            "type": "line-height"
          },
          "name": "LineHeightMeHeadline3",
          "attributes": {
            "category": "line-height",
            "type": "me",
            "item": "headline",
            "subitem": "3"
          },
          "path": [
            "line-height",
            "me",
            "headline",
            "3"
          ]
        },
        "4": {
          "value": "32px",
          "type": "line-height",
          "original": {
            "value": "32px",
            "type": "line-height"
          },
          "name": "LineHeightMeHeadline4",
          "attributes": {
            "category": "line-height",
            "type": "me",
            "item": "headline",
            "subitem": "4"
          },
          "path": [
            "line-height",
            "me",
            "headline",
            "4"
          ]
        },
        "5": {
          "value": "24px",
          "type": "line-height",
          "original": {
            "value": "24px",
            "type": "line-height"
          },
          "name": "LineHeightMeHeadline5",
          "attributes": {
            "category": "line-height",
            "type": "me",
            "item": "headline",
            "subitem": "5"
          },
          "path": [
            "line-height",
            "me",
            "headline",
            "5"
          ]
        },
        "6": {
          "value": "24px",
          "type": "line-height",
          "original": {
            "value": "24px",
            "type": "line-height"
          },
          "name": "LineHeightMeHeadline6",
          "attributes": {
            "category": "line-height",
            "type": "me",
            "item": "headline",
            "subitem": "6"
          },
          "path": [
            "line-height",
            "me",
            "headline",
            "6"
          ]
        }
      },
      "body": {
        "value": "24px",
        "type": "line-height",
        "original": {
          "value": "24px",
          "type": "line-height"
        },
        "name": "LineHeightMeBody",
        "attributes": {
          "category": "line-height",
          "type": "me",
          "item": "body"
        },
        "path": [
          "line-height",
          "me",
          "body"
        ]
      },
      "small": {
        "value": "16px",
        "type": "line-height",
        "original": {
          "value": "16px",
          "type": "line-height"
        },
        "name": "LineHeightMeSmall",
        "attributes": {
          "category": "line-height",
          "type": "me",
          "item": "small"
        },
        "path": [
          "line-height",
          "me",
          "small"
        ]
      },
      "label": {
        "value": "20px",
        "type": "line-height",
        "original": {
          "value": "20px",
          "type": "line-height"
        },
        "name": "LineHeightMeLabel",
        "attributes": {
          "category": "line-height",
          "type": "me",
          "item": "label"
        },
        "path": [
          "line-height",
          "me",
          "label"
        ]
      }
    },
    "rwl": {
      "headline": {
        "1": {
          "value": "64px",
          "type": "line-height",
          "original": {
            "value": "64px",
            "type": "line-height"
          },
          "name": "LineHeightRwlHeadline1",
          "attributes": {
            "category": "line-height",
            "type": "rwl",
            "item": "headline",
            "subitem": "1"
          },
          "path": [
            "line-height",
            "rwl",
            "headline",
            "1"
          ]
        },
        "2": {
          "value": "56px",
          "type": "line-height",
          "original": {
            "value": "56px",
            "type": "line-height"
          },
          "name": "LineHeightRwlHeadline2",
          "attributes": {
            "category": "line-height",
            "type": "rwl",
            "item": "headline",
            "subitem": "2"
          },
          "path": [
            "line-height",
            "rwl",
            "headline",
            "2"
          ]
        },
        "3": {
          "value": "48px",
          "type": "line-height",
          "original": {
            "value": "48px",
            "type": "line-height"
          },
          "name": "LineHeightRwlHeadline3",
          "attributes": {
            "category": "line-height",
            "type": "rwl",
            "item": "headline",
            "subitem": "3"
          },
          "path": [
            "line-height",
            "rwl",
            "headline",
            "3"
          ]
        },
        "4": {
          "value": "32px",
          "type": "line-height",
          "original": {
            "value": "32px",
            "type": "line-height"
          },
          "name": "LineHeightRwlHeadline4",
          "attributes": {
            "category": "line-height",
            "type": "rwl",
            "item": "headline",
            "subitem": "4"
          },
          "path": [
            "line-height",
            "rwl",
            "headline",
            "4"
          ]
        },
        "5": {
          "value": "24px",
          "type": "line-height",
          "original": {
            "value": "24px",
            "type": "line-height"
          },
          "name": "LineHeightRwlHeadline5",
          "attributes": {
            "category": "line-height",
            "type": "rwl",
            "item": "headline",
            "subitem": "5"
          },
          "path": [
            "line-height",
            "rwl",
            "headline",
            "5"
          ]
        },
        "6": {
          "value": "24px",
          "type": "line-height",
          "original": {
            "value": "24px",
            "type": "line-height"
          },
          "name": "LineHeightRwlHeadline6",
          "attributes": {
            "category": "line-height",
            "type": "rwl",
            "item": "headline",
            "subitem": "6"
          },
          "path": [
            "line-height",
            "rwl",
            "headline",
            "6"
          ]
        }
      },
      "body": {
        "value": "24px",
        "type": "line-height",
        "original": {
          "value": "24px",
          "type": "line-height"
        },
        "name": "LineHeightRwlBody",
        "attributes": {
          "category": "line-height",
          "type": "rwl",
          "item": "body"
        },
        "path": [
          "line-height",
          "rwl",
          "body"
        ]
      },
      "small": {
        "value": "16px",
        "type": "line-height",
        "original": {
          "value": "16px",
          "type": "line-height"
        },
        "name": "LineHeightRwlSmall",
        "attributes": {
          "category": "line-height",
          "type": "rwl",
          "item": "small"
        },
        "path": [
          "line-height",
          "rwl",
          "small"
        ]
      },
      "label": {
        "value": "20px",
        "type": "line-height",
        "original": {
          "value": "20px",
          "type": "line-height"
        },
        "name": "LineHeightRwlLabel",
        "attributes": {
          "category": "line-height",
          "type": "rwl",
          "item": "label"
        },
        "path": [
          "line-height",
          "rwl",
          "label"
        ]
      }
    }
  },
  "radius": {
    "klr": {
      "1": {
        "value": "0",
        "type": "radius",
        "original": {
          "value": "0",
          "type": "radius"
        },
        "name": "RadiusKlr1",
        "attributes": {
          "category": "radius",
          "type": "klr",
          "item": "1"
        },
        "path": [
          "radius",
          "klr",
          "1"
        ]
      }
    },
    "me": {
      "1": {
        "value": "2px",
        "type": "radius",
        "original": {
          "value": "2px",
          "type": "radius"
        },
        "name": "RadiusMe1",
        "attributes": {
          "category": "radius",
          "type": "me",
          "item": "1"
        },
        "path": [
          "radius",
          "me",
          "1"
        ]
      },
      "2": {
        "value": "8px",
        "type": "radius",
        "original": {
          "value": "8px",
          "type": "radius"
        },
        "name": "RadiusMe2",
        "attributes": {
          "category": "radius",
          "type": "me",
          "item": "2"
        },
        "path": [
          "radius",
          "me",
          "2"
        ]
      }
    },
    "rwl": {
      "1": {
        "value": "4px",
        "type": "radius",
        "original": {
          "value": "4px",
          "type": "radius"
        },
        "name": "RadiusRwl1",
        "attributes": {
          "category": "radius",
          "type": "rwl",
          "item": "1"
        },
        "path": [
          "radius",
          "rwl",
          "1"
        ]
      },
      "2": {
        "value": "8px",
        "type": "radius",
        "original": {
          "value": "8px",
          "type": "radius"
        },
        "name": "RadiusRwl2",
        "attributes": {
          "category": "radius",
          "type": "rwl",
          "item": "2"
        },
        "path": [
          "radius",
          "rwl",
          "2"
        ]
      },
      "3": {
        "value": "24px",
        "type": "radius",
        "original": {
          "value": "24px",
          "type": "radius"
        },
        "name": "RadiusRwl3",
        "attributes": {
          "category": "radius",
          "type": "rwl",
          "item": "3"
        },
        "path": [
          "radius",
          "rwl",
          "3"
        ]
      }
    }
  },
  "shadow": {
    "klr": {
      "1": {
        "value": "0px 4px 0px #971323",
        "type": "shadow",
        "original": {
          "value": "0px 4px 0px #971323",
          "type": "shadow"
        },
        "name": "ShadowKlr1",
        "attributes": {
          "category": "shadow",
          "type": "klr",
          "item": "1"
        },
        "path": [
          "shadow",
          "klr",
          "1"
        ]
      }
    },
    "me": {
      "1": {
        "value": "0px 1px 0px #900005",
        "type": "shadow",
        "original": {
          "value": "0px 1px 0px #900005",
          "type": "shadow"
        },
        "name": "ShadowMe1",
        "attributes": {
          "category": "shadow",
          "type": "me",
          "item": "1"
        },
        "path": [
          "shadow",
          "me",
          "1"
        ]
      },
      "2": {
        "value": "0px 0px 20px rgba(0, 0, 0, 0.15)",
        "type": "shadow",
        "original": {
          "value": "0px 0px 20px rgba(0, 0, 0, 0.15)",
          "type": "shadow"
        },
        "name": "ShadowMe2",
        "attributes": {
          "category": "shadow",
          "type": "me",
          "item": "2"
        },
        "path": [
          "shadow",
          "me",
          "2"
        ]
      }
    },
    "rwl": {
      "1": {
        "value": "0px 2px 2px rgba(0, 0, 0, 0.15)",
        "type": "shadow",
        "original": {
          "value": "0px 2px 2px rgba(0, 0, 0, 0.15)",
          "type": "shadow"
        },
        "name": "ShadowRwl1",
        "attributes": {
          "category": "shadow",
          "type": "rwl",
          "item": "1"
        },
        "path": [
          "shadow",
          "rwl",
          "1"
        ]
      },
      "2": {
        "value": "0px 4px 4px rgba(0, 0, 0, 0.15)",
        "type": "shadow",
        "original": {
          "value": "0px 4px 4px rgba(0, 0, 0, 0.15)",
          "type": "shadow"
        },
        "name": "ShadowRwl2",
        "attributes": {
          "category": "shadow",
          "type": "rwl",
          "item": "2"
        },
        "path": [
          "shadow",
          "rwl",
          "2"
        ]
      },
      "3": {
        "value": "0px 1px 1px rgba(0, 0, 0, 0.15)",
        "type": "shadow",
        "original": {
          "value": "0px 1px 1px rgba(0, 0, 0, 0.15)",
          "type": "shadow"
        },
        "name": "ShadowRwl3",
        "attributes": {
          "category": "shadow",
          "type": "rwl",
          "item": "3"
        },
        "path": [
          "shadow",
          "rwl",
          "3"
        ]
      },
      "4": {
        "value": "0px 0px 20px rgba(0, 0, 0, 0.15)",
        "type": "shadow",
        "original": {
          "value": "0px 0px 20px rgba(0, 0, 0, 0.15)",
          "type": "shadow"
        },
        "name": "ShadowRwl4",
        "attributes": {
          "category": "shadow",
          "type": "rwl",
          "item": "4"
        },
        "path": [
          "shadow",
          "rwl",
          "4"
        ]
      }
    }
  },
  "font-family": {
    "rwl": {
      "base": {
        "value": "'Ubuntu', sans-serif",
        "type": "font-family",
        "original": {
          "value": "'Ubuntu', sans-serif",
          "type": "font-family"
        },
        "name": "FontFamilyRwlBase",
        "attributes": {
          "category": "font-family",
          "type": "rwl",
          "item": "base"
        },
        "path": [
          "font-family",
          "rwl",
          "base"
        ]
      },
      "body": {
        "value": "'Ubuntu', sans-serif",
        "type": "font-family",
        "original": {
          "value": "'Ubuntu', sans-serif",
          "type": "font-family"
        },
        "name": "FontFamilyRwlBody",
        "attributes": {
          "category": "font-family",
          "type": "rwl",
          "item": "body"
        },
        "path": [
          "font-family",
          "rwl",
          "body"
        ]
      }
    }
  }
};
}))
